/**
 * External Dependencies
 */
import 'jquery';
import Swiper from 'swiper/bundle';

// Swiper 
(function () {
  // Product gallery
  var swiperHero = new Swiper('.swiper-hero', {
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
})();